export enum SkillResourceSteps {
  ABOUT_THE_SKILL,
  WORKED_EXAMPLE,
  PRACTICE_PROBLEMS,
  SKILL_CHALLENGE,
  PRE_SKILL_CHALLENGE,
}
